/* Flag.js - Component that returns an image of the flag
 * depending on the countryCode passed in throught props.
 * The prop countryCode is specified by using Alpha-2 code
 */

import React, { Suspense } from "react"
import { Img } from "react-image"
import _ from "lodash"



import {
Avatar
} from "evergreen-ui"

// Javascript libraries
import { getCountry } from "../js/getCountry"

import { DropdownItem } from "shards-react"

class Flag extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      country: getCountry(this.props.countryCode || "JM")
    }
  }

  render() {
    if (this.props.asDropdown) {
      return (
        <DropdownItem
          href={this.props.removeLink ? "#" : this.state.country.href}
        >
          <Img
            src={this.state.country.src}
            alt={this.state.country.alt}
            style={this.props.style ? this.props.style : { width: "25px" }}
          />
          {this.props.showName ? (
            <p className="ml-2" style={{ display: "inline-block " }}>
              {_.truncate(this.state.country.name, {
                length: 20,
                omission: "..."
              })}
            </p>
          ) : (
            <React.Fragment />
          )}
        </DropdownItem>
      )
    } else {
      return (
        <a href={this.props.removeLink ? "#" : this.state.country.href}>
          <Img
            src={this.state.country.src}
            alt={this.state.country.alt}
            style={this.props.style ? this.props.style : { width: "25px" }}
          />
          {this.props.showName ? (
            <p className="ml-2" style={{ display: "inline-block " }}>
              {_.truncate(this.state.country.name, {
                length: 20,
                omission: "..."
              })}
            </p>
          ) : (
            <React.Fragment />
          )}
        </a>
      )
    }
  }
}

export default Flag
